webpackJsonp([183471839103005],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _caseStudy = __webpack_require__(380);
	
	var _caseStudy2 = _interopRequireDefault(_caseStudy);
	
	__webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'case-hero' },
	      _react2.default.createElement('div', { className: 'case-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'case-title' },
	      'Case Study'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'case-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'why', current: 'case-study' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'case-study-section-title' },
	        'Company Background:'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'case-study-section' },
	        _caseStudy2.default.background
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'case-study-section-title' },
	        'What was the Need?'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'case-study-section' },
	        _caseStudy2.default.needs.map(function (paragraph, i) {
	          return _react2.default.createElement(
	            'p',
	            { key: i, className: 'needs-paragraph' },
	            paragraph
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'case-study-section-title' },
	        'What were the Terms of the Lease:'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'case-study-section' },
	        _caseStudy2.default.terms
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'case-study-section-title' },
	        'Results:'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'case-study-section' },
	        _caseStudy2.default.results
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	module.exports = {"background":"Cherokee Carpet Industries of Dalton, Georgia is a manufacturer of residential and commercial carpeting. With 315 employees, Cherokee Carpet Industries boasts $50 million a year in revenues. In its five years in business, Cherokee Carpet has grown rapidly. 1999 was the first year that Cherokee Carpet will have audited financial statements. Equipment Leasing Solutions As a closely held and highly leveraged S-corporation, to grow its company, Cherokee was looking for strategic financing methods that would position the company for the next level. Since its inception, Cherokee has leveraged the benefits of leasing as a strategy to grow the company. At present, the company leases $150,000 annually in equipment.","needs":["Rapid growth in its five years in business continues to present a need for Cherokee Carpet to minimize its capital requirements. Cherokee Carpet Industries had a need for a Plantex 36 End Extruder for polypropylene and nylon carpet yarns, an industrial piece of equipment. Cherokee Carpet considered a straight purchase of $3.5 million for the piece of equipment, but discovered that leasing afforded them the opportunity to leverage their financial resources. When the company weighed the opportunity costs of a straight out purchase against the lease payments, leasing offered a better solution.","Cherokee recognized equipment leasing would provide tax benefits as well as preserve operating capital. The primary reason Cherokee Carpet chose to lease versus purchase the industrial piece of equipment was because as the company was rapidly expanding, leasing offered Cherokee Carpet the ability to maximize cash flow. Therefore Cherokee Carpet had more capital available for the operation of the company and for business growth investments."],"terms":"The equipment leasing company structured the lease to help Cherokee Carpet Industries minimize its capital requirements. The lease was negotiated to the terms of a seven year capital lease with an early buy out (EBO) option at three and five years and limits on fair market value.","results":"Leasing equipment as a financing option afforded Cherokee Carpets the ability to leverage their capital, increase cash flow and maintain more funds for business expenditures. The equipment leasing company was able to customize a program to meet Cherokee Carpet's financial and equipment needs."}

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-case-study-js-095e2926edceb6f343cd.js